export default [
  'wine_type_wine',
  'wine_type_fresh_grape_must_fermentation_arrested',
  'wine_type_new_wine_still_in_fermentation',
  'wine_type_liqueur_wine',
  'wine_type_sparkling_wine',
  'wine_type_quality_sparkling_wine',
  'wine_type_quality_aromatic_sparkling_wine',
  'wine_type_aerated_sparkling_wine',
  'wine_type_semi_sparkling_wine',
  'wine_type_aerated_semi_sparkling_wine',
  'wine_type_grape_must',
  'wine_type_partially_fermented_grape_must',
  'wine_type_de_alcoholised_wine',
  'wine_type_partially_de_alcoholised_wine',
  'wine_type_de_alcoholised_sparkling_wine',
  'wine_type_partially_de_alcoholised_sparkling_wine',
  'wine_type_de_alcoholised_quality_sparkling_wine',
  'wine_type_partially_de_alcoholised_quality_sparkling_wine',
  'wine_type_de_alcoholised_quality_aromatic_sparkling_wine',
  'wine_type_partially_de_alcoholised_quality_aromatic_sparkling_wine',
  'wine_type_de_alcoholised_aerated_sparkling_wine',
  'wine_type_partially_de_alcoholised_aerated_sparkling_wine',
  'wine_type_de_alcoholised_semi_sparkling_wine',
  'wine_type_partially_de_alcoholised_semi_sparkling_wine',
  'wine_type_de_alcoholised_aerated_semi_sparkling_wine',
  'wine_type_partially_de_alcoholised_aerated_semi_sparkling_wine'
]
